import React, { useState } from 'react';
import Header from '../components/header';
import { Container, Typography, Box, Button, Modal } from '@mui/material';
import '../styles/opiniones.css';
import { useLanguage } from '../context/LanguageContext';

const recipesData = [
  {
    title: 'MOUSSE DE CAMARON',
    image: require('../image/recetas/MouseeCamaron.png'),
    ingredients: `* Camarones limpios y pelados
* Queso crema
* Mayonesa
* Aceite sacha inchi
* Zumo de limón
* Sal
* Pimienta
* Perejil fresco
* Tomate cherry
* Crambol (harina de trigo y mantequilla)

Para el crambol:
* 1/2 taza de harina de SACHA INCHI
* 1/2 taza de harina integral o de avena libre de gluten
* 1/2 taza de mantequilla
* 2 cucharadas de azúcar morena
* Sal
* Nuez o almendra (opcional)`,
    preparation: `1. Aderezamos los camarones con un poco de sal y limón.
2. En una licuadora o procesadora agregamos yema de huevo, queso crema, jugo de limón, sal y pimienta.
3. Incorporamos una cucharadita de aceite de SACHA INCHI y volvemos a procesar para dar sabor y perfume característico.
4. Picamos finamente el camarón y lo incorporamos a la mezcla batida.
5. Revolvemos hasta formar una mousse cremosa y suave.
6. Refrigeramos mínimo una hora para dar firmeza.

Para el crambol:
1. Mezclamos la harina SACHA INCHI, harina integral y sal; perfumamos con romero.
2. Agregamos la mantequilla cortada en cuadritos y mezclamos con los dedos formando grumos.
3. Opcional: agregamos las nueces picadas para dar crocancia.
4. Precalentamos el horno a 180°C, colocamos la masa en una lata y horneamos por 30 minutos hasta obtener un tono dorado.
5. Dejamos enfriar.
6. Decoramos la mousse de camarón con el crambol, perejil fresco y tomate cherry.`
  },
  {
    title: 'SATEY DE CERDO CON SALSA DE TAMARINDO',
    image: require('../image/recetas/SATEY DE CERDO.png'),
    ingredients: `* Lomito fino de cerdo
* Pimiento
* Cebolla perla
* Sal
* Pimienta
* Ajo
* Azúcar morena
* Paprika
* Salsa de tamarindo con aceite de SACHA INCHI`,
    preparation: `1. Cortamos el lomo en cubos aproximados de 2x2 cm y lo salpimentamos.
2. Agregamos la panela previamente disuelta en agua con paprika y ajo.
3. Sumergimos los cubos de cerdo en esta mezcla por un mínimo de tres horas.
4. Cortamos cebolla perla y pimiento rojo en cuadros de 2x2 cm.
5. Intercalamos cebolla, pimiento y cerdo para formar los satey.`
  },
  {
    title: 'SALSA DE TAMARINDO',
    image: require('../image/recetas/SalsaTamarindo.png'),
    ingredients: `* Pulpa de tamarindo (concentrado o natural, remojado y colado)
* Azúcar morena
* Salsa soya
* Vinagre blanco
* Aceite de SACHA INCHI
* Chile`,
    preparation: `1. Remojamos 50 g de tamarindo en agua caliente por 15 minutos, colamos y usamos solo la pulpa.
2. En una licuadora, combinamos la pulpa de tamarindo, azúcar morena, soya, chile, limón y aceite de SACHA INCHI.
3. Colocamos la mezcla en un sartén u olla a fuego moderado.
4. Ajustamos sal y acidez al gusto. Si está muy espesa, agregamos un chorrito de agua tibia y un toque de vinagre blanco, batiendo hasta obtener una consistencia cremosa y reducida.`
  },
  {
    title: 'CREPES RELLENOS DE POLLO Y CHAMPIÑON',
    image: require('../image/recetas/crepePollo.png'),
    ingredients: `* Harina de SACHA INCHI y harina de trigo
* Pechuga de pollo
* Champiñones
* Crema de leche
* Queso mozzarella
* Sal
* Pimienta
* Aceite de albahaca`,
    preparation: `1. Batimos los huevos con la leche y el aceite.
2. Añadimos la harina de SACHA INCHI, harina de trigo y sal. Mezclamos en la licuadora hasta obtener una mezcla líquida y sin grumos.
3. Tamizamos la mezcla para evitar grumos y dejamos reposar 10–15 minutos.
4. Cocinamos los crepes en un sartén antiadherente con mantequilla o aceite, dorando cada lado.
5. Para el relleno, cocemos la pechuga con aromáticas y sal, desmenuzamos el pollo y lo enfriamos.
6. Salteamos los champiñones con ajo y cebolla, agregamos el pollo, la crema de leche y el queso mozzarella. Mezclamos hasta obtener una consistencia homogénea.
7. Rellenamos los crepes y servimos.`
  },
  {
    title: 'MUFFIN DE ARANDANOS',
    image: require('../image/recetas/MUFFIN.png'),
    ingredients: `* 1/2 taza de harina de SACHA INCHI
* 1 taza de harina de avena
* 1 cucharadita de polvo de hornear
* 1/4 de cucharadita de sal
* 1/2 taza de azúcar morena
* 2 huevos
* 2 cucharaditas de aceite de coco
* 1 cucharadita de esencia de vainilla
* Banano
* Arándanos
* Ralladura de limón
* Canela en polvo`,
    preparation: `1. Mezclamos los ingredientes secos: en un bowl grande combinamos harina de SACHA INCHI, harina de avena, polvo de hornear, sal y azúcar.
2. Mezclamos los ingredientes húmedos: en otro bowl batimos los huevos con el aceite, la vainilla y la ralladura de limón.
3. Incorporamos los ingredientes húmedos a los secos, mezclando suavemente con una espátula hasta que no queden grumos.
4. Añadimos los bananos y arándanos suavemente.
5. Rellenamos los moldes hasta 3/4 de su capacidad con la mezcla.
6. Horneamos por 20–25 minutos a 160°C.
7. Servimos caliente, opcionalmente con una bola de helado de pistacho.`
  }
];

const recipesDataEn = [
  {
    title: 'SHRIMP MOUSSE',
    image: require('../image/recetas/MouseeCamaron.png'),
    ingredients: `* Cleaned, peeled shrimp
* Cream cheese
* Mayonnaise
* Sacha inchi oil
* Lemon juice
* Salt and pepper
* Fresh parsley
* Cherry tomato

For the crumble:
* 1/2 cup SACHA INCHI flour
* 1/2 cup whole wheat or oat flour
* 1/2 cup butter
* 2 tbsp brown sugar
* Salt` ,
    preparation: `1. Season shrimp with salt and lemon.
2. Blend egg yolk, cream cheese, lemon juice, salt, and pepper.
3. Add a teaspoon of SACHA INCHI oil and blend again.
4. Finely chop shrimp and fold into the mixture.
5. Refrigerate for at least one hour.
6. Decorate with crumble, parsley, and cherry tomato.`
  },
  {
    title: 'PORK SATEY WITH TAMARIND SAUCE',
    image: require('../image/recetas/SATEY DE CERDO.png'),
    ingredients: `* Pork tenderloin
* Red pepper
* Pearl onion
* Salt, pepper, garlic
* Brown sugar
* Paprika
* Tamarind sauce with SACHA INCHI oil`,
    preparation: `1. Cut pork into cubes and season.
2. Marinate with dissolved panela, paprika, and garlic for 3 hours.
3. Cut onion and pepper into cubes.
4. Assemble skewers alternating vegetables and pork.`
  },
  {
    title: 'TAMARIND SAUCE',
    image: require('../image/recetas/SalsaTamarindo.png'),
    ingredients: `* Tamarind pulp
* Brown sugar
* Soy sauce
* White vinegar
* SACHA INCHI oil
* Chili`,
    preparation: `1. Soak tamarind in hot water and strain.
2. Blend tamarind pulp with sugar, soy, chili, lemon, and SACHA INCHI oil.
3. Cook on medium heat.
4. Adjust salt, acidity, and consistency as needed.`
  },
  {
    title: 'CHICKEN AND MUSHROOM STUFFED CREPES',
    image: require('../image/recetas/crepePollo.png'),
    ingredients: `* SACHA INCHI flour and wheat flour
* Chicken breast
* Mushrooms
* Cream
* Mozzarella
* Salt and pepper`,
    preparation: `1. Beat eggs with milk and oil.
2. Add flours and salt, blend until smooth.
3. Cook crepes in a non-stick pan.
4. Prepare filling with shredded chicken, mushrooms, cream, and cheese.
5. Fill crepes and serve.`
  },
  {
    title: 'BLUEBERRY MUFFIN',
    image: require('../image/recetas/MUFFIN.png'),
    ingredients: `* 1/2 cup SACHA INCHI flour
* 1 cup oat flour
* Baking powder
* Brown sugar
* Eggs
* Coconut oil
* Vanilla
* Banana
* Blueberries`,
    preparation: `1. Mix dry ingredients.
2. Mix wet ingredients.
3. Combine both mixtures and fold fruit gently.
4. Fill molds up to 3/4.
5. Bake 20-25 minutes at 160C.`
  }
];

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '88%',
  maxWidth: 500,
  bgcolor: 'var(--panel-elevated)',
  boxShadow: 24,
  p: 4,
  borderRadius: '20px',
  border: '1px solid var(--panel-border)'
};

const Recetas = () => {
  const { language } = useLanguage();
  const [openModal, setOpenModal] = useState(false);
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [activeTab, setActiveTab] = useState('ingredients');

  const content = {
    es: {
      eyebrow: 'Ideas para disfrutar',
      title: 'Recetario',
      subtitle: 'Descubre nuestras recetas con el toque especial que te encantara.',
      details: 'Ver detalles',
      ingredients: 'Ingredientes',
      preparation: 'Preparacion',
      close: 'Cerrar'
    },
    en: {
      eyebrow: 'Ideas to enjoy',
      title: 'Recipe Book',
      subtitle: 'Discover our recipes with the special touch you will love.',
      details: 'View details',
      ingredients: 'Ingredients',
      preparation: 'Preparation',
      close: 'Close'
    }
  };

  const t = content[language];
  const localizedRecipes = language === 'en' ? recipesDataEn : recipesData;

  const handleOpenModal = (recipe) => {
    setSelectedRecipe(recipe);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRecipe(null);
    setActiveTab('ingredients');
  };

  return (
    <div className="recetas-container page-shell">
      <Header />
      <Container maxWidth="lg" className="recetas-content">
        <Box className="recetas-header">
          <Typography className="section-eyebrow">{t.eyebrow}</Typography>
          <Typography variant="h4" className="title">
            {t.title}
          </Typography>
          <Typography variant="body1" className="subtitle">
            {t.subtitle}
          </Typography>
          <hr className="separator" />
        </Box>
        <div className="recetas-grid">
          {localizedRecipes.map((recipe, index) => (
            <Box key={index} className="receta-card">
              <img src={recipe.image} alt={recipe.title} className="receta-image" />
              <Box className="receta-info">
                <Typography variant="h5" className="receta-title">{recipe.title}</Typography>
                <Box className="receta-button-container">
                  <Button variant="contained" onClick={() => handleOpenModal(recipe)}>
                    {t.details}
                  </Button>
                </Box>
              </Box>
            </Box>
          ))}
        </div>
      </Container>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={modalStyle} className="modal-content">
          {selectedRecipe && (
            <>
              <Typography variant="h6" component="h2" gutterBottom>
                {selectedRecipe.title}
              </Typography>
              <Box className="modal-toggle">
                <Button
                  variant={activeTab === 'ingredients' ? 'contained' : 'outlined'}
                  onClick={() => setActiveTab('ingredients')}
                >
                  {t.ingredients}
                </Button>
                <Button
                  variant={activeTab === 'preparation' ? 'contained' : 'outlined'}
                  onClick={() => setActiveTab('preparation')}
                >
                  {t.preparation}
                </Button>
              </Box>
              {activeTab === 'ingredients' && (
                <Typography variant="body2" gutterBottom style={{ whiteSpace: 'pre-line' }}>
                  {selectedRecipe.ingredients}
                </Typography>
              )}
              {activeTab === 'preparation' && (
                <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                  {selectedRecipe.preparation}
                </Typography>
              )}
              <Box mt={2}>
                <Button variant="contained" onClick={handleCloseModal}>
                  {t.close}
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default Recetas;
